import { getPackageUniqueKey } from 'lib/offer/offerUtils'

export function getHotelSearchBestPackage({
  bestPriceError,
  bestMaybeAvailableRate,
  hasFiltersSet,
  metaData,
  offer,
  shouldUseRealSearchPrices,
  duration,
}: {
  bestPriceError: boolean
  bestMaybeAvailableRate: App.OfferMaybeAvailableRate | undefined
  hasFiltersSet: boolean
  metaData: App.OfferListMetaData | undefined
  offer: App.HotelOffer
  shouldUseRealSearchPrices: boolean
  duration: number | undefined
}): App.HotelPackage | undefined {
  if (!shouldUseRealSearchPrices) {
    if (!hasFiltersSet || bestPriceError) {
      return offer.lowestPricePackage
    }
    if (bestMaybeAvailableRate?.rate) {
      const bestPricePkg = offer.packages.find(pkg => pkg.uniqueKey === bestMaybeAvailableRate.rate.packageUniqueKey)
      return bestPricePkg ?? offer.lowestPricePackage
    }
  } else {
    // use search pricing package id by default
    const pkgId = metaData?.pricing?.lowestPricePackageId ?? offer.lowestPricePackage?.id
    if (!pkgId || !duration || !bestMaybeAvailableRate?.rate?.roomRateId) {
      return offer.lowestPricePackage
    }

    const pkg = offer.packages.find(pkg => pkg.uniqueKey === getPackageUniqueKey(pkgId, duration, bestMaybeAvailableRate.rate.roomRateId))
    return pkg ?? offer.lowestPricePackage
  }
}
